<template>
    <div v-if="localValues">
        <div class="col-sm-12 col-xs-12 test">
            <div class="ibox">
                <div class="ibox-title  Forms_checklists_data questions-form-and-checklist">
                    <div class="row m-bottom-10" style="padding-left: 15px;">
                        <!--        Forms & checklists title-->
                        <div class="inline-block">
                            <div class="drag-tool">
                                <span>
                                    <span class="select-services-dropdown-title">Decline Booking Questions</span>
<!--                                    <a>-->
<!--                                        <svg data-target="#popupi" data-toggle="modal" fill="none" height="20"-->
<!--                                             style="fill: #CBCFD3; position:relative; bottom: -4px" viewBox="0 0 20 20"-->
<!--                                             width="20" xmlns="http://www.w3.org/2000/svg" @click="infoPopup">-->
<!--                                            <path-->
<!--                                                d="M10 0C4.48 0 0 4.48 0 10C0 15.52 4.48 20 10 20C15.52 20 20 15.52 20 10C20 4.48 15.52 0 10 0ZM11 17H9V15H11V17ZM13.07 9.25L12.17 10.17C11.45 10.9 11 11.5 11 13H9V12.5C9 11.4 9.45 10.4 10.17 9.67L11.41 8.41C11.78 8.05 12 7.55 12 7C12 5.9 11.1 5 10 5C8.9 5 8 5.9 8 7H6C6 4.79 7.79 3 10 3C12.21 3 14 4.79 14 7C14 7.88 13.64 8.68 13.07 9.25Z"-->
<!--                                                fill="#CBCFD3"></path>-->
<!--                                        </svg>-->
<!--                                    </a>-->
                                </span>
                            </div>
                        </div>
                    </div>
                    <div class="form-group p-0-14 add_border_to_div " v-for="(localValue, index) of localValues"  :class="{'custom-field-ibox-content forms-ibox-padding white-bg additional-comments':true}">
                        <div class="ibox rotate-div">
                            <div :data-target="`#forms_checklists_toggle_${index}`"
                                 @click="collapseAndExtendForm(localValue.user_id)"
                                 class=" ibox-title data_ibox_title_val"    >
                                <div>
                                    <label  class="attribute-label  float-left"   role="button">
                                        <label class="label-form new-design-heading-label">
                                        </label>
                                    </label>
                                    <div class="inline float-right new-design-heading-label">
                                        <div class="inline arrow-container float-right  m-right-10 m-left-10  "  >
                                            <a class="" role="button">
                                                <i class="fa fa-chevron-down" style="color: #2E4051" ref="toggleIcon"></i>
                                            </a>
                                        </div>
                                        <div class="float-left">
                                            <span style="font-size: 10px;">Updated  {{localValue.date}}
                                                <span v-if="localValue.user_name != null">by  {{localValue.user_name}}</span>
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div :id="`forms_checklists_toggle_1`" v-show="localValue.collapsed"  >
                                <fieldset class="octopus-new-booking-fieldset col-md-12" style="margin-top: 20px; margin-bottom: 0px"  >
                                    <div class="custom-field">
                                        <div  v-for="(question, index) of localValue.questions">
                                            <label for="question_238432_0" class="attribute-label" v-if="index === 0 || question?.question_id !== localValue?.questions[index - 1].question_id">
                                                {{question.question_text}}
                                            </label>
                                            <div> <spam>{{question.answer}}</spam></div>
                                        </div>
                                        <div  v-for="(comment, index) of localValue.comments">
                                            <label class="attribute-label">
                                                Comment :-
                                            </label>
                                            <div><spam>{{comment.comment}}</spam></div>
                                        </div>

                                    </div>
                                </fieldset>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>

import {getCommentRejectedBooking} from "@/modules/DeclineBooking/api"
import {EventBus} from "../../../events/event-bus";

export default {
    name: "DeclineBookingQuestions",
    props: {
        itemId:null,
        value: null
    },
    data() {
        return {
            localValues: null,
        };
    },
    methods: {
        collapseAndExtendForm(id) {
            if(this.localValues[id].collapsed){
                this.expandForm(id);

            } else{
                this.collapseForm(id);
            }
            this.$forceUpdate()
        },
        collapseForm(id) {
            this.localValues[id].collapsed = true;
            $(this.$refs.toggleIcon).toggleClass('rotate-180')

            // EventBus.$emit('onChangeCheckListStatus',this.form.form_id , true);
        },
        expandForm(id) {
            this.localValues[id].collapsed = false;
            $(this.$refs.toggleIcon).toggleClass('rotate-180')
            // EventBus.$emit('onChangeCheckListStatus',this.form.form_id , false);
        }
    },
    mounted() {
        getCommentRejectedBooking(this.itemId).then((response) => {
                this.localValues = response.data;
        })
        .catch((error) => {
            // Handle any errors here
        });
    }
}
</script>


<style scoped>
.custom-field{
    width: 100%;
}
.custom-field .new-inputs textarea {
    font: none !important;
}

.service_auto_generate_title{
    font-size: 13px !important;
    font-weight: 100;
}

.custom-field-ibox-content {
    width: 100%;
}
.border-none {
    border: none;
}

.p-left-unset {
    padding-left: unset;
}

.form-horizontal .form-group {
    margin-right: 0px;
    margin-left: 0px;
}
.new-design-heading-label {
    font-family: 'Roboto', serif;
    font-style: normal;
    font-weight: 600;
    font-size: 13px;
    line-height: 35px;
    color: #2E4051;
}

.additional-comments{
    padding-bottom: 10px !important;
}
.octopus-new-booking-fieldset{
    margin-left:10px !important;
    margin-right:10px !important;
    width: 98%;
}
.data_ibox_title_val
{
    border-top: 0px;padding: 14px 15px 15px;
    border-radius: 12px !important;
    cursor: pointer;
}

.add_border_to_div{
    border: 1px solid #EAECEE;
    border-radius: 12px;
}

.Forms_checklists_data{
    background-color:transparent ;
    font-size: 13px !important;
    font-weight: 100;
    padding: 5px;
    border-color: transparent!important;
    color: #2E4051 !important;
    font-family: 'Roboto', sans-serif;
    font-style: normal;
}

.ibox{
    width: 100%;
    margin: 10px auto;
}


@media (max-width: 769px) {

    .Forms_checklists_data
    {
        padding: 0px;
    }

    .octopus-new-booking-fieldset{
        width: 95% !important;
    }


    .test{
        padding: 5px;
    }

}

@media (max-width: 1025px) {
    .ibox {
        width: 98%;
    }

}

@media (min-width: 768px) and (max-width: 1024px) {
    .octopus-new-booking-fieldset{
        width: 97% !important;
    }
}

@media (max-width: 426px) {

    .test{
        padding: 5px;
    }

    .octopus-new-booking-fieldset, fieldset{
        margin-left: 0px !important;
        margin-right: 0px !important;

    }

    .octopus-new-booking-fieldset{
        width: 100% !important;
    }

}
</style>